import { compose, createStore, applyMiddleware } from 'redux';
import rootReducer from './reducers/index';
import Thunk from 'redux-thunk';

export default function createFinalStore() {
  const finalCreateStore = compose(applyMiddleware(Thunk))(createStore);
  return finalCreateStore(rootReducer);
}


// WEBPACK FOOTER //
// ./src/store.js